import { FunctionComponent } from 'react';
import { useSearchParams } from 'react-router';

type SearchParametersOrderByProperties = {
    options: { label: string; value: string }[];
};

export const SearchParametersOrderBy: FunctionComponent<SearchParametersOrderByProperties> = ({ options }) => {
    const [searchParameters, setSearchParameters] = useSearchParams();
    const orderBy = (searchParameters.get('orderBy') as string) || '';

    return (
        <select
            className="block w-full appearance-none rounded-md border border-gray-200 py-1.5 text-sm leading-6 text-gray-600 shadow-sm focus:border-gray-300 focus:ring-0"
            data-testid="search-parameters-order-by"
            id="orderBy"
            name="orderBy"
            onChange={(event) => {
                const orderByValue = event.target.value;

                if (orderByValue === '') {
                    searchParameters.delete('orderBy');
                } else {
                    searchParameters.set('orderBy', orderByValue);
                }

                searchParameters.delete('page');

                setSearchParameters(searchParameters);
            }}
            value={orderBy}
        >
            {options.map((option) => {
                return (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                );
            })}
        </select>
    );
};
